import { createShuffled } from '@/services/book/exercise-parsers';
import { ExerciseConverted } from '@/interfaces/class/exercises';
import { Training } from '@/interfaces/class/training';

export default (el: Training, exercise: ExerciseConverted) => ({
  ...el,
  allAllowedTrainingTypes: ['AudioChoosePhrase'],
  allowedTrainingTypes: ['AudioChoosePhrase'],
  enFillers: el.en,
  enFillersShuffled: createShuffled(exercise, el.en, 'en', 'phrase'),
});
